export default __webpack_public_path__ + "static/media/2.006e4467.jpg";